import { OnDestroy, OnInit, Directive } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PaginationPage, PaginationResponse, Widget, WidgetUserFilter } from './classes';
import { FilterType, FilterTypeCriteria } from './components/edit/edit-userfilter/edit-userfilter.component';
import { CustomChartView } from './components/widget/widget/widget.component';

@Directive()
export class AbstractWidgetInner implements OnDestroy, OnInit {

    public _data: WidgetInnerData;
    set data(data: WidgetInnerData) {
        this._data = data;
    }
    get data(): WidgetInnerData {
        return this._data;
    }

    currentChartView: CustomChartView;
    currentFilterType: FilterType<number>;

    public viewSubscriptions: Subscription[] = [];

    ngOnDestroy(): void {
        for (let subscription of this.viewSubscriptions) subscription.unsubscribe();
        this.viewSubscriptions = [];
    }
    ngOnInit(): void { }
    receiveChartView(view: CustomChartView) {
        console.warn("no action for the passed chart view ...", view);
    }
    receiveIFrame(href: string) {
        console.warn("no action for the passed iframe ...", href);
    }
    receiveUserFilter(filter: WidgetUserFilter) {
        console.warn("no action for the passed chart view ...", filter);
    }
    receiveRoleFilter() {

    }
    refresh = () => console.warn("no action for refresh method ...");
}

@Directive()
export class AbstractListWidgetInner<T> extends AbstractWidgetInner {

    entries: T[];

    sortAttribute: string;
    sortDsc: boolean;

    viewTitle: string = null;

    stringSearchProvider: (search: string, paginationPage: PaginationPage ) => Observable<PaginationResponse<T[]>>;
    userFilterSearchProvider: (filterId: number, paginationPage: PaginationPage ) => Observable<PaginationResponse<T[]>>;

    page = new BehaviorSubject<PaginationPage>({ pageSize: 20, pageNumber: 1 });
    totalItems: number = 0;

    showSearchInput: boolean = false;
    searchFilter: string = "";

    userFilterIdentifier: number = 0;

    private _mainSub: Subscription = null;

    constructor() {
        super();
    }
    loadMore() {
        if (this.entries && this.entries.length && this.entries.length < this.totalItems) {
            let page = this.page.value;
            page.pageNumber++;
            this.page.next(page);
        }
    }
    ngOnDestroy(): void {
        super.ngOnDestroy();
        if (this._mainSub) this._mainSub.unsubscribe();
        this._mainSub = null;
    }
    receiveUserFilter(filter: WidgetUserFilter) {
        this.userFilterIdentifier = filter.filterid;
        this.viewTitle = `Eigener Nutzerfilter '${filter && filter.filtertext? filter.filtertext: 'kein Filtertitel'}'`;
        this.sortAttribute = filter.filtersortattribute;
        this.sortDsc = filter.filtersortdsc;
        this.updateContentProvider(this.page.asObservable().pipe(switchMap((page: PaginationPage) => this.userFilterSearchProvider(filter.filterid, page))));
      }
    sendSearch = () => {
        this.viewTitle = `Suche nach '${this.searchFilter}'`;
        this.updateContentProvider(this.page.asObservable().pipe(switchMap((page: PaginationPage) => this.stringSearchProvider(this.searchFilter, page))));
    }
    setFilter(criteria: FilterTypeCriteria<number>) {
        if (criteria.value == this.sortAttribute) this.sortDsc = !this.sortDsc;
        else {
            this.sortAttribute = criteria.value;
            this.sortDsc = false;
        }
        this.sortEntries();
    }
    sortEntries() {
        var d = 1;
        if (this.sortDsc) d = -1;
        this.entries.sort((a, b) => {
            if (!a[this.sortAttribute]) return -1 * d;
            if (!b[this.sortAttribute]) return d;
            if (a[this.sortAttribute] == b[this.sortAttribute]) return 0;
            return a[this.sortAttribute] > b[this.sortAttribute] ? d : -1 * d;
        });
    }
    setServerResponse(result: PaginationResponse<T[]>) {
        if (result.page.pageNumber === 1) this.entries = result.content;
        else this.entries = [...this.entries, ...result.content];
        this.totalItems = result.totalItems;
    }
    updateContentProvider(obs: Observable<PaginationResponse<T[]>>) {
        if (this._mainSub) this._mainSub.unsubscribe();
        this._mainSub = null;
        this.page.value.pageNumber = 1;
        this._mainSub = obs.subscribe((result) => this.setServerResponse(result));
    }
}

export class WidgetInnerData {
    widget: Widget;
    data?: AbstractWidgetInnerData;
    widgetInteractionSubject: Subject<number> = new Subject();
    subject: Subject<WidgetInnerView[]> = new Subject();
}

export interface AbstractWidgetInnerData {

}

export class WidgetInnerView {
    name: () => Observable<string>;
    icon: () => Observable<string>;
    color?: () => Observable<string>;
    onClick: () => Observable<void>;
}